// import { createSlice } from "@reduxjs/toolkit";
// import Cookies from "js-cookie";

// const getInitialState = () => {
//   // Read directly from cookies on initialization
//   const token = Cookies.get("access_token");
//   const refresh = Cookies.get("refresh_token");
//   const role = Cookies.get("user_role");
  
//   return {
//     token: token || null,
//     refresh: refresh || null,
//     role: role || null,
//     isAuthenticated: !!token,
//     loading: false,
//     error: null,
//   };
// };

// const initialState = getInitialState();

// const authSlice = createSlice({
//   name: "auth",
//   initialState,
//   reducers: {
//     loginStart(state) {
//       state.loading = true;
//       state.error = null;
//     },
//     loginSuccess(state, action) {
//       state.token = action.payload.access_token;
//       state.refresh = action.payload.refresh_token;

//       state.role = Array.isArray(action.payload.role) && action.payload.role.length > 0
//         ? action.payload.role[0]
//         : null;

//       state.isAuthenticated = true;
//       state.loading = false;
//       state.error = null;

//       // Save tokens 
//       Cookies.set("access_token", action.payload.access_token, { expires: 1 }); // 5 minutes
//       Cookies.set("refresh_token", action.payload.refresh_token, { expires: 1 });
//       Cookies.set("user_role", state.role, { expires: 1 });
//     },
//     loginFailure(state, action) {
//       state.loading = false;
//       state.error = action.payload;
//       state.token = null;
//       state.refresh = null;
//       state.user = null;
//       state.role = null;
//       state.isAuthenticated = false;
//       Cookies.remove("access_token");
//       Cookies.remove("refresh_token");
//       Cookies.remove("user_role");
//     },
//     logout(state) {
//       state.token = null;
//       state.refresh = null;
//       state.role = null;
//       state.isAuthenticated = false;
//       state.loading = false;
//       state.error = null;
//       Cookies.remove("access_token");
//       Cookies.remove("refresh_token");
//       Cookies.remove("user_role");
//     },
//     setToken(state, action) {
//       state.token = action.payload;
//       state.isAuthenticated = !!action.payload;
//       Cookies.set("access_token", action.payload,{ expires: 1 }); // 5 minutes
//     },
//     refreshTokenStart(state) {
//       state.loading = true;
//     },
//     refreshTokenSuccess(state, action) {
//       state.token = action.payload.access;
//       state.isAuthenticated = true;
//       state.loading = false;
//       state.error = null;
      
//       // Always update cookies
//       if (action.payload.access) {
//         Cookies.set("access_token", action.payload.access, {expires: 1 }); 
//       }
      
//       // Also update refresh token if new one is provided
//       if (action.payload.refresh) {
//         state.refresh = action.payload.refresh;
//         Cookies.set("refresh_token", action.payload.refresh, { expires: 1 });
//       }
//     },
//     refreshTokenFailure(state, action) {
//       state.loading = false;
//       state.error = action.payload;
//       state.token = null;
//       state.refresh = null;
//       state.role = null;
//       state.isAuthenticated = false;
//       Cookies.remove("access_token");
//       Cookies.remove("refresh_token");
//       Cookies.remove("user_role");
//     },
//   },
// });

// export const { 
//   loginStart, 
//   loginSuccess, 
//   loginFailure, 
//   logout, 
//   setToken,
//   refreshTokenStart,
//   refreshTokenSuccess,
//   refreshTokenFailure
// } = authSlice.actions;
// export default authSlice.reducer;


import { createSlice } from "@reduxjs/toolkit";
import Cookies from "js-cookie";

const getInitialState = () => {
  const token = Cookies.get("access_token");
  const refresh = Cookies.get("refresh_token");
  const role = Cookies.get("user_role");

  return {
    token: token || null,
    refresh: refresh || null,
    role: role || null,
    roleVerified: false, // flips true only after /auth/my-roles/ confirms it
    isAuthenticated: !!token,
    loading: false,
    error: null,
  };
};

const initialState = getInitialState();

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    loginStart(state) {
      state.loading = true;
      state.error = null;
    },
    loginSuccess(state, action) {
      state.token = action.payload.access_token;
      state.refresh = action.payload.refresh_token;

      state.role = Array.isArray(action.payload.role) && action.payload.role.length > 0
        ? action.payload.role[0]
        : null;

      // Caller (Login.jsx) already confirmed this role against
      // /auth/my-roles/ before dispatching this action.
      state.roleVerified = true;
      state.isAuthenticated = true;
      state.loading = false;
      state.error = null;

      Cookies.set("access_token", action.payload.access_token, { expires: 1 });
      Cookies.set("refresh_token", action.payload.refresh_token, { expires: 1 });
      Cookies.set("user_role", state.role, { expires: 1 });
    },
    loginFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
      state.token = null;
      state.refresh = null;
      state.role = null;
      state.roleVerified = false;
      state.isAuthenticated = false;
      Cookies.remove("access_token");
      Cookies.remove("refresh_token");
      Cookies.remove("user_role");
    },
    logout(state) {
      state.token = null;
      state.refresh = null;
      state.role = null;
      state.roleVerified = false;
      state.isAuthenticated = false;
      state.loading = false;
      state.error = null;
      Cookies.remove("access_token");
      Cookies.remove("refresh_token");
      Cookies.remove("user_role");
    },
    setToken(state, action) {
      state.token = action.payload;
      state.isAuthenticated = !!action.payload;
      Cookies.set("access_token", action.payload, { expires: 1 });
    },
    refreshTokenStart(state) {
      state.loading = true;
    },
    refreshTokenSuccess(state, action) {
      state.token = action.payload.access;
      state.isAuthenticated = true;
      state.loading = false;
      state.error = null;

      if (action.payload.access) {
        Cookies.set("access_token", action.payload.access, { expires: 1 });
      }

      if (action.payload.refresh) {
        state.refresh = action.payload.refresh;
        Cookies.set("refresh_token", action.payload.refresh, { expires: 1 });
      }
    },
    refreshTokenFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
      state.token = null;
      state.refresh = null;
      state.role = null;
      state.roleVerified = false;
      state.isAuthenticated = false;
      Cookies.remove("access_token");
      Cookies.remove("refresh_token");
      Cookies.remove("user_role");
    },
    roleConfirmed(state) {
      state.roleVerified = true;
    },
    roleRejected(state, action) {
      state.token = null;
      state.refresh = null;
      state.role = null;
      state.roleVerified = false;
      state.isAuthenticated = false;
      state.error = action.payload || "Unauthorized role. Please log in again.";
      Cookies.remove("access_token");
      Cookies.remove("refresh_token");
      Cookies.remove("user_role");
    },
  },
});

export const {
  loginStart,
  loginSuccess,
  loginFailure,
  logout,
  setToken,
  refreshTokenStart,
  refreshTokenSuccess,
  refreshTokenFailure,
  roleConfirmed,
  roleRejected,
} = authSlice.actions;

export default authSlice.reducer;